import $ from 'jquery';

export default function searchfilter() {
  const filters = $('[data-search-filter]').not('[data-search-filter=all]');
  const allFilter = $('[data-search-filter=all]');

  allFilter.on('change', () => {
    filters.attr('checked', false);
  });

  filters.on('change', () => {
      allFilter.attr('checked', false);
  });

  filters.closest('form').on('submit', () => {
    if ( allFilter.prop('checked') === true) {
      allFilter.prop('disabled', true);
    }
  });
}


// WEBPACK FOOTER //
// ./scripts/lib/search/searchfilter.js